import React from 'react';
import './DiscountBanner.scss';

const DiscountBanner = ({ autoDiscounts, paymentMethods }) => {
  if (!autoDiscounts?.length || !paymentMethods?.length) return null;

  const bannerRows = [];

  // Recorremos cada escala
  autoDiscounts.forEach(tier => {
    const groups = {}; // Objeto para agrupar: { "28": ["Efectivo", "Transferencia"] }

    paymentMethods.forEach(pm => {
      // Si el medio permite el descuento automático (candado abierto)
      if (pm.allow_discount == 1 || pm.allow_discount === true) {
        // Cálculo cascada real: 1 - (Neto Escala * Neto Medio Pago)
        const totalOff = Math.round(
          (1 - (1 - parseFloat(tier.percentage) / 100) * (1 - (parseFloat(pm.percent) || 0))) * 100
        );

        if (!groups[totalOff]) groups[totalOff] = [];
        groups[totalOff].push(pm.name);
      }
    });

    // Pasamos los grupos a filas para el render
    Object.entries(groups).forEach(([percent, names]) => {
      bannerRows.push({
        min: tier.amount,
        totalOff: percent,
        pmNames: names.join(', ')
      });
    });
  });

  if (bannerRows.length === 0) return null;

  return (
    <div className="transfer-scales-banner">
      <div className="scales-row">
        {bannerRows.map((row, i) => (
          <div key={i} className="scale-item">
            {` [ A partir de $${parseFloat(row.min).toLocaleString('de-DE')}, ${row.totalOff}% OFF con ${row.pmNames} en la compra] `}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DiscountBanner;